<template>
    <div class="page">
        <public-head title="报考政策"></public-head>
        <div class="menu">
            <div v-for="(item,index) in lists" :key="index">
                <div
                    :class="firstNavId === item.id?'menu-item-on':'menu-item-off'"
                    @click="selectMenu(item,index)"
                >
                    <div>{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="choose" v-if="bottomNav.length>0">
            <div v-for="(item,index) in bottomNav" :key="index">
                <div class="nav-con">
                    <div
                        @click="choose(item,index)"
                        :class="secondNavId === item.id?'header':'nav-con'"
                    >{{item.name}}</div>
                </div>
            </div>
        </div>
        <div v-if="policyList.length>0">
            <!-- 报考政策 -->
            <div v-if="index===0">
                <div v-for="(item,index) in policyList" :key="index" class="botom">
                    <div class="list" @click="goPolicyDetail(item)">
                        <div class="list-name">{{item.name}}</div>
                        <div class="arrow"></div>
                    </div>
                </div>
            </div>
            <!-- 报考流程 -->
            <div v-if="index===1">
                <div class="container">
                    <div class="step-title">一站式分类招生流程</div>
                    <div v-for="(item,index) in policyList" :key="index">
                        <div class="step-container">
                            <div class="step">
                                <div class="step-circle">
                                    <div class="step-inner-circle">{{index+1}}</div>
                                </div>
                                <div :class="'step-line'+index"></div>
                            </div>
                            <div class="content1">
                                <div class="step-content">
                                    <div class="step-item-title">{{item.name}}</div>
                                    <div class="step-item-content">
                                        <p v-html="item.content"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 报考咨询 -->
            <div v-if="index==2">
                <div v-for="(item,index) in policyList" :key="index" class="botom">
                    <div class="list" @click="goPolicyDetail(item.id)">
                        <div class="list-name">{{item.name}}</div>
                        <div class="arrow"></div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="_noPost">
            <img
                src="https://new.schoolpi.net/attach/small_program/index/no-data.png"
                class="no-data"
            />
        </div>
    </div>
</template>

<script>
import PublicHead from "../../../components/publicHead";
import { httpPost } from "../../../axios/index";
export default {
    data() {
        return {
            show: false,
            firstNavId: 0, //第一层id、
            secondNavId: 0, //第二层id
            lists: [],
            bottomNav: [],
            cate_id: 1, //报考政策id,
            index: 0,
            policyList: []
        };
    },
    created() {},
    methods: {
        //跳转到详情
        goPolicyDetail(e) {
            var id = e.id;
            this.$router.push({
                path: "/fenlei/policyDetail",
                query: {
                    id: id
                }
            });
        },
        // 获取报考政策分类菜单数据
        fetchCate() {
            httpPost("/classifie/policy_cate", {
                province: this.$store.state.areaInfo.pid
            }).then(res => {
                if (res.code === 1) {
                    this.firstNavId = res.list[0].id;
                    this.bottomNav = res.list[0].child;
                    if (this.bottomNav.length > 0) {
                        this.lists = res.list;
                        this.secondNavId = this.bottomNav[0].id;
                        this.fetchPolicyList(this.secondNavId);
                    } else {
                        (this.lists = res.list),
                            (this.firstNavId = res.list[0].id),
                            this.fetchPolicyList(this.firstNavId);
                    }
                }
            });
        },
        // 点击一级导航获取的数据
        selectMenu(e, i) {
            var id = e.id;
            var index = i;
          
            if (e.child.length == 0) {
                (this.firstNavId = id),
                    // this.secondNavId=id,
                    (this.index = i);
                this.fetchPolicyList(id);
            } else {
                let secondNavId = e.child[0].id;
                this.firstNavId = id;
                this.secondNavId = secondNavId;
                this.bottomNav = e.child;
                this.index = 0;
                this.fetchPolicyList(id);
            }
        },
        // 点击二级导航获取数据
        choose(e, i) {
           
            var id = e.id;

            this.secondNavId = id;
            this.index = i;
            this.fetchPolicyList(id);
        },
        //获取报考政策列表数据
        fetchPolicyList(cate_id) {
            httpPost("/classifie/policy_list", {
                province: this.$store.state.areaInfo.pid,
                cate_id: cate_id
            }).then(res => {
                if (res.code === 1) {
                    this.policyList = res.list;
                } else {
                    this.policyList = [];
                }
            });
        }
    },
    mounted() {
        this.fetchCate();
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
.page {
    background: #f2f2f2;
}
.botom{
    border-bottom: 1px solid #ccc;
}
.menu {
    padding: 0 0.9375rem;
    height: 3.125rem;
    line-height: 3.125rem;
    display: flex;
    justify-content: space-around;
    background: #22d8d9;
    color: #fff;
    font-size: 0.875rem;
    margin-top: 46px;
}
.choose {
    height: 3.9375rem;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 0.8125rem 0;
}
.menu-item-on {
    font-size: 1.125rem;
}

.list {
    padding: 0.9375rem 1.25rem;
    display: flex;
    justify-content: space-between;
    background: #fff;
    color: #383838;
    border-bottom: 1rpx solid #ccc;
    position: relative;
    font-size: 0.9375rem;
}

.list:last-child {
    border: none;
}

.arrow {
    position: absolute;
    right: 12px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 10px;
    height: 10px;
    border-top: 2px solid gainsboro;
    border-right: 2px solid gainsboro;
    transform: rotate(45deg);
}
.container {
    background: #fff;
    padding-top: 1.1875rem;
}

.step-title {
    width: 18.75rem;
    text-align: center;
    margin: 0rpx auto 3.125rem auto;
    height: 2.5rem;
    line-height: 2.5rem;
    background-color: #22d8d9;
    color: #fff;
    font-size: 1.0625rem;
    border-radius: 1.25rem;
    margin: auto;
    margin-bottom: 30px;
}

.step-container {
    display: flex;
    margin: 0 0.9375rem;
}

.step {
    width: 3.125rem;
    display: flex;
    flex-direction: column;
    position: relative;
}

.step-circle {
    position: relative;
    width: 1.875rem;
    height: 1.875rem;
    text-align: center;
    line-height: 1.875rem;
    margin: 0 auto;
    font-size: 1.25rem;
    background-color: #d3f7f7;
    color: #fff;
    border-radius: 50%;
}

.step-inner-circle {
    width: 1.25rem;
    height: 1.25rem;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    margin: auto auto;
    line-height: 1.25rem;
    border-radius: 50%;
    background-color: #22d8d9;
}

.step-line0,
.step-line1,
.step-line2,
.step-line3,
.step-line4,
.step-line5,
.step-line6,
.step-line7,
.step-line8 {
    flex: 1;
    width: 0.125rem;
    margin: 0 auto;
    background: #22d8d9;
}

.content1 {
    flex: 1;
    margin-top: -0.75rem;
    box-sizing: border-box;
    width: 15rem;
}

.step-content {
    padding: 0.9375rem;
    background: #f2f2f2;
    margin-bottom: 1.25rem;
    border-radius: 10px;
}

.step-item-title {
    font-size: 1.0625rem;
    color: #000;
    font-weight: bold;
    padding-bottom: 0.9375rem;
    border-bottom: solid 2px #ccc;
}

.step-item-content {
    padding-top: 0.9375rem;
    font-size: 0.875rem;
}

.jiangsu {
    width: 100%;
    display: flex;
    height: 7.0625rem;
    justify-content: space-around;
}

.header {
    width: 100%;
    text-align: center;
    line-height: 2.125rem;
    background: #22d8d9;
    color: #fff;
    font-size: 0.875rem;
    border-radius: 0.9375rem;
}

.nav-con {
    width: 6.5rem;
    height: 2.125rem;
    background: #e6e6e6;
    border-radius: 0.9375rem;
    text-align: center;
    line-height: 2.125rem;
}
._noPost {
    text-align: center;
    position: relative;
}
.no-data {
    width: 6.25rem;
    height: 7.1875rem;
    position: absolute;
    top: 10.9375rem;
    left: 0;
    right: 0;
    margin: auto;
}
</style>